import type { ReactElement } from "react";
import * as React from "react";
import * as palette from "../palette";

export default function UnsupportedBrowser() {
  return (
    <div
      css={{
        maxWidth: 620,
        margin: "72px auto",
      }}
    >
      <div
        css={{
          display: "grid",
          gridRowGap: 20,
          justifyContent: "center",
        }}
      >
        <div
          css={{
            textAlign: "center",
          }}
        >
          <Browser />
        </div>

        <h1
          css={{
            margin: 0,
            color: palette.mariner,
            fontWeight: "bold",
            fontSize: 28,
            lineHeight: 1.33,
            letterSpacing: 1.4,
            textAlign: "center",
          }}
        >
          Seu navegador não é compatível :(
        </h1>

        <p
          css={{
            margin: 0,
            color: palette.blueBayoux,
            fontWeight: 500,
            fontSize: 16,
            lineHeight: 1.33,
            letterSpacing: 1.2,
            textAlign: "center",
            "& > a": {
              color: palette.link,
              "&:visited": {
                color: palette.linkVisited,
              },
            },
          }}
        >
          Esta página não é acessível com o navegador que você está usando. Tente baixar o{" "}
          <a href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer">
            Google Chrome
          </a>
          ,{" "}
          <a href="https://support.apple.com/downloads/safari" target="_blank" rel="noopener noreferrer">
            Safari
          </a>
          ,{" "}
          <a href="https://www.mozilla.org/pt-BR/firefox/new/" target="_blank" rel="noopener noreferrer">
            Firefox
          </a>{" "}
          ou{" "}
          <a href="https://www.microsoft.com/pt-br/windows/microsoft-edge" target="_blank" rel="noopener noreferrer">
            Microsoft Edge
          </a>
          .
        </p>

        <p
          css={{
            margin: 0,
            color: palette.baliHai,
            fontWeight: 500,
            fontSize: 14,
            lineHeight: 1.33,
            letterSpacing: 1.2,
            textAlign: "center",
          }}
        >
          © {new Date().getFullYear()} Fundamentei
        </p>
      </div>
    </div>
  );
}

function Browser(props: React.SVGProps<any>): ReactElement {
  return (
    <svg width={94} height={94} {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M92.087 0H1.913A1.913 1.913 0 000 1.913v90.174a1.913 1.913 0 003.826 0V20.402h76.968a1.913 1.913 0 000-3.826H3.826V3.826h86.348v86.348H21.176a1.913 1.913 0 000 3.826h70.911A1.913 1.913 0 0094 92.087V1.913A1.913 1.913 0 0092.087 0z"
          fill="#4364F6"
          fillRule="nonzero"
        />
        <g fillRule="nonzero" fill="#4364F6">
          <path d="M36.864 67.714l7.09 5.229V53.628h8.144a5 5 0 003.993-1.99l3.818-5.067H36.864v21.143zM35.09 43.048L28 36h39l-5.318 7.048z" />
        </g>
        <path
          d="M9.584 9.584A2.03 2.03 0 009 11.002c0 .527.214 1.04.584 1.414.373.37.887.584 1.414.584a2.03 2.03 0 001.418-.584c.37-.373.584-.887.584-1.414 0-.527-.214-1.045-.584-1.418A2.03 2.03 0 0010.998 9c-.523 0-1.04.214-1.414.584zM15.587 9.584A2.02 2.02 0 0015 11.002c0 .523.213 1.04.587 1.414.37.37.886.584 1.413.584s1.043-.214 1.413-.584c.373-.373.587-.887.587-1.414 0-.527-.214-1.045-.587-1.418A2.014 2.014 0 0017 9c-.527 0-1.043.214-1.413.584zM20.583 9.586c-.37.373-.583.89-.583 1.416 0 .523.213 1.039.583 1.412.374.37.887.586 1.414.586.526 0 1.043-.216 1.416-.586.373-.373.587-.89.587-1.412 0-.527-.214-1.043-.587-1.416A2.033 2.033 0 0021.997 9c-.527 0-1.04.216-1.414.586z"
          fill="#2F4EDA"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}
